import { render, staticRenderFns } from "./About.vue?vue&type=template&id=52462727&scoped=true&"
var script = {}
import style0 from "./About.vue?vue&type=style&index=0&id=52462727&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52462727",
  null
  
)

export default component.exports